import { capacitorService } from '../../../../application/CapacitorService';
import { revenueCatService } from '../../../../application/RevenueCatService';
import { usePermissions } from '../../hooks/usePermissions';
import { useUpgradeDialogVisibility } from '../../hooks/useUpgradeDialogVisibility';
import { UpgradeSubscriptionNativeDialog } from './UpgradeSubscriptionNativeDialog';
import { UpgradeSubscriptionWebDialog } from './UpgradeSubscriptionWebDialog';

export const FREE_STOP_LIMIT = 10; // Drivers:Free limit. I have added them here in case we use it in a text
export const FREE_ROUTES_LIMIT = 1; // Drivers:Free limit.

export const UpgradeSubscriptionComponent = () => {
  const { isSoloDriver, hasSubscription } = usePermissions();
  const { visible: upgradeSubscriptionDialog, setDialogVisibility } = useUpgradeDialogVisibility();
  const showModal = upgradeSubscriptionDialog && isSoloDriver && !hasSubscription && revenueCatService.isLogged();

  if (showModal && !capacitorService.isWeb()) {
    return <UpgradeSubscriptionNativeDialog onClose={() => setDialogVisibility(false)} />;
  }
  if (showModal && capacitorService.isWeb()) {
    return <UpgradeSubscriptionWebDialog onClose={() => setDialogVisibility(false)} />;
  }
  return null;
};
